import { FC } from 'react';
import { MdOutlineUploadFile } from 'react-icons/md';
import s from './qr-editor-settings.module.css';
import { QrEditorProps, useQrEditorSettings } from './use-qr-editor-settings';
import { Button } from '../../../../../../../../components/button/button';
import { Container } from '../../../../../../../../components/container/container';
import { InputFile } from '../../../../../../../../components/input-file/input-file';
import { Input } from '../../../../../../../../components/input/input';
import { Select } from '../../../../../../../../components/select/select';

export const QrEditorSettings: FC<QrEditorProps> = (props) => {
  const { handleSelectTemplate, handleUpdateName, handleUpload, t, template, templates } =
    useQrEditorSettings(props);

  return (
    <div className={s.feature}>
      <Container label={t('Выберите шаблон')}>
        <Select
          options={templates}
          value={templates.find((item) => item.id === template?.id) || templates[0]}
          onSelect={handleSelectTemplate}
        />
      </Container>

      <Container label={t('Название')} required>
        <Input value={template?.name} name="name" onChange={handleUpdateName} />
      </Container>

      <InputFile types={['image/*']} onChange={handleUpload} name="img">
        <Button variant="secondary">
          <MdOutlineUploadFile />
          {t('Загрузить шаблон QR кода')}
        </Button>
      </InputFile>
    </div>
  );
};
